export default "__VITE_ASSET__X7qz$mKv__"